import React from 'react';
import PropTypes from 'prop-types';

export function Toggle(props) {
  const { className, id, onChange, value } = props;

  const handleOnChange = e => {
    onChange(id, e.target.checked);
  };

  return (
    <div className={`pxl-toggle ${className}`}>
      <input
        className="pxl-toggle__check"
        id={id}
        onChange={handleOnChange}
        type="checkbox"
        value={value}
        checked={value}
      />
      <label className="pxl-toggle__button" htmlFor={id}/>
    </div>
  );
}

Toggle.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired
};

Toggle.defaultProps = {
  className: ''
};

export default Toggle